import { render, staticRenderFns } from "./toShopping.vue?vue&type=template&id=4186b8d8&scoped=true&"
import script from "./toShopping.vue?vue&type=script&lang=js&"
export * from "./toShopping.vue?vue&type=script&lang=js&"
import style0 from "./toShopping.vue?vue&type=style&index=0&id=4186b8d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186b8d8",
  null
  
)

export default component.exports